export const colors = {
    orange: "#FBB74D",
    hellBlau: "#9CCCC5",
    turkis: "#0D7770",
    magenta: "#9C0572",
    grau: "#7E8484",
    gruen: "#888E02"
}